import React from 'react';
import PromoBanner from './PromoBanner';

const PromoBanners = props =>
  props.banners.map((banner, idx) => <PromoBanner key={idx} promoBanner={banner} />);

export default PromoBanners;



// WEBPACK FOOTER //
// ./src/client/js/view/components/PromoBanners/PromoBanners.js